/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const addMessage = /* GraphQL */ `
  subscription AddMessage {
    addMessage {
      messageId
      content
      sendTo
      createdAt
      handle
    }
  }
`;
